var cardStyles = {
  "card": {
    "background": "#fff",
    "boxShadow": "0 1px 1px 0 rgba(0, 0, 0, 0.1)",
    "height": "100%",
    "position": "relative",
    "width": "100%"
  },
  "cardFlex": {
    "display": "flex",
    "flexFlow": "column wrap"
  },
  "cardFlex__padResponsive": {
    "flex": "1 0 auto"
  },
  "cardRelative": {
    "display": "flex",
    "flexFlow": "column"
  },
  "cardRelative___div": {
    "flex": "0 1 auto",
    "&:last-of-type": {
      "flex": "1 0 auto",
      "display": "flex",
      "flexDirection": "column",
      "justifyContent": "flex-end"
    }
  },
  "cardRounded": {
    "border": "1px solid #ecedee",
    "borderRadius": "4px"
  },
  "cardContent": {
    "WebkitBackfaceVisibility": "hidden",
    "backfaceVisibility": "hidden",
    "display": "inline-block",
    "maxWidth": "984px !important",
    "position": "relative",
    "width": "100%"
  }
};

export default cardStyles;
